import CUSTOMER from './customer/customerServer';

export default {
    CUSTOMER
}
